import * as stylex from "@stylexjs/stylex";
import { FooterLink } from "./footer-link";
import { localStyles } from "./site-footer-sitemap.styles";
import type {
  SiteFooterLinkItem,
  SiteFooterLinkRenderer,
} from "./site-footer-types";
import type { ReactNode } from "react";

export function SiteFooterSitemap({
  homeHref,
  browseItems,
  productItems,
  aboutItems,
  legalItems,
  renderLink,
  renderSignedInOnly,
}: {
  readonly homeHref: string;
  readonly browseItems: readonly SiteFooterLinkItem[];
  readonly productItems: readonly SiteFooterLinkItem[];
  readonly aboutItems: readonly SiteFooterLinkItem[];
  readonly legalItems: readonly SiteFooterLinkItem[];
  readonly renderLink: SiteFooterLinkRenderer;
  readonly renderSignedInOnly: (children: ReactNode) => ReactNode;
}) {
  return (
    <div {...stylex.props(localStyles.sitemap)}>
      <div {...stylex.props(localStyles.column)}>
        <p {...stylex.props(localStyles.heading)}>Leagues</p>
        <div {...stylex.props(localStyles.links)}>
          {browseItems.map((link) => (
            <FooterLink key={link.href} link={link} renderLink={renderLink} />
          ))}
        </div>
      </div>
      <div {...stylex.props(localStyles.column, localStyles.products)}>
        <p {...stylex.props(localStyles.heading)}>Products</p>
        <div {...stylex.props(localStyles.links)}>
          {productItems.map((link) => (
            <FooterLink key={link.href} link={link} renderLink={renderLink} />
          ))}
        </div>
      </div>
      <div {...stylex.props(localStyles.column, localStyles.about)}>
        <p {...stylex.props(localStyles.heading)}>About</p>
        {renderSignedInOnly(
          <FooterLink
            link={{ label: "Home", href: homeHref }}
            renderLink={renderLink}
          />,
        )}
        {aboutItems.map((link) => (
          <FooterLink key={link.href} link={link} renderLink={renderLink} />
        ))}
      </div>
      <div {...stylex.props(localStyles.column)}>
        <p {...stylex.props(localStyles.heading)}>Legal</p>
        <div {...stylex.props(localStyles.links)}>
          {legalItems.map((link) => (
            <FooterLink key={link.href} link={link} renderLink={renderLink} />
          ))}
        </div>
      </div>
    </div>
  );
}
